import type {
  DrugEntity,
  DrugPropsPub,
  DrugPropsPvt,
} from './entity/drugEntity';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { DrugJsonPub, DrugJsonPvt } from '@/types/domain/drug/entities/drugEntity';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * 薬ドメインサービス(施設)
 */
export class DrugNurseryDomainService extends DomainServiceBase {
  private wagakoNurseryApi!: WagakoNurseryIApi;

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   */
  public inject(
    wagakoNurseryApi: WagakoNurseryIApi,
  ) {
    this.wagakoNurseryApi = wagakoNurseryApi;
  }

  /**
   * sendNurseryDrug
   * @param entity entity
   */
  async sendNurseryDrug(
    entity: DrugEntity,
  ) {
    await this.wagakoNurseryApi.send<
      DrugPropsPvt,
      DrugJsonPvt,
      DrugPropsPub,
      DrugJsonPub
    >(entity);
  }

  /**
   * removeNurseryDrug
   * @param entity entity
   */
  async removeNurseryDrug(
    entity: DrugEntity,
  ) {
    await this.wagakoNurseryApi.remove<
      DrugPropsPvt,
      DrugJsonPvt,
      DrugPropsPub,
      DrugJsonPub
    >(entity);
  }
}
